// Common iOS activity types that can be excluded
export const ActivityTypes = {
  POST_TO_FACEBOOK: 'com.apple.UIKit.activity.PostToFacebook',
  POST_TO_TWITTER: 'com.apple.UIKit.activity.PostToTwitter',
  POST_TO_WEIBO: 'com.apple.UIKit.activity.PostToWeibo',
  MESSAGE: 'com.apple.UIKit.activity.Message',
  MAIL: 'com.apple.UIKit.activity.Mail',
  PRINT: 'com.apple.UIKit.activity.Print',
  COPY_TO_PASTEBOARD: 'com.apple.UIKit.activity.CopyToPasteboard',
  ASSIGN_TO_CONTACT: 'com.apple.UIKit.activity.AssignToContact',
  SAVE_TO_CAMERA_ROLL: 'com.apple.UIKit.activity.SaveToCameraRoll',
  ADD_TO_READING_LIST: 'com.apple.UIKit.activity.AddToReadingList',
  POST_TO_FLICKR: 'com.apple.UIKit.activity.PostToFlickr',
  POST_TO_VIMEO: 'com.apple.UIKit.activity.PostToVimeo',
  POST_TO_TEN_CENT_WEIBO: 'com.apple.UIKit.activity.PostToTencentWeibo',
  AIRDROP: 'com.apple.UIKit.activity.AirDrop',
  OPEN_IN_IBOOKS: 'com.apple.UIKit.activity.OpenInIBooks',
  MARKUP_AS_PDF: 'com.apple.UIKit.activity.MarkupAsPDF',
};

